import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getHotel, getHotelRooms, type HotelRoomsParams } from '../services/api/hotels.api';

/** Dates-independent property detail, cached by id. */
export function useHotel(id: string | undefined) {
  return useQuery({
    queryKey: ['hotel', id],
    queryFn: () => getHotel(id as string),
    enabled: !!id,
  });
}

/** Dates-dependent rooms + per-stay pricing; keepPreviousData so date edits don't flash. */
export function useHotelRooms(id: string | undefined, params: HotelRoomsParams) {
  return useQuery({
    queryKey: ['hotel', id, 'rooms', params],
    queryFn: () => getHotelRooms(id as string, params),
    enabled: !!id,
    placeholderData: keepPreviousData,
  });
}
